import Action from './action';

import { IOption } from '../../../components/Select'

const initialState = {
    phoneType: { en: "CN", enName: "Chinese", id: "+86", localName: "Chinese", name: "中国" },
    phoneNumber: '',
    errorText: '',
    showBox: false
};

interface IAction {
    phoneType: IOption,
    phoneNumber: string,
}

export default (state = initialState, action: {type: string, playload: any}) => {
    switch (action.type) {
        case Action.UPDATE_PHONE_GROUP: {
            return {
                ...state,
                phoneType: (action.playload as IAction).phoneType,
                phoneNumber: (action.playload as IAction).phoneNumber
            }
        }
        case Action.UPDATE_PHONE_GROUP_ERROR_TEXT: {
            try {
                action.playload && (window as any).mailStats.show('phone_error', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.playload
            }
        }
        case Action.UPDATE_SHOW_SMS_BOX: {
            return {
                ...state,
                showBox: action.playload
            }
        }
        default: return state;
    }
}
